export const APIURLS = {
    onEmailSend: "api/v1/UserProfile/ForgotPassword?emailAddress=",
    getContentWidgetDetails: "api/v1/Dashboards",
    ContentWidgets: "api/v1/ContentWidgets",
    updateTemplate: "api/v1/ContentWidgets",
    getProfileIdByEmail: "api/v1/UserProfile/ProfileByEmailId",
    getBearerToken: "api/v1/Account/GetToken",
    getInvalid_accesstoken: "api/v1/UserProfile/ProfileByEmailId?UserEmail=",
    getContentWidget: "api/v1/ContentWidgets/GetWidgetContentList",
    getHealthCheckData: "api/v1/HealthCheck/GetHealthCheckLogs",
    getAllNotificationData: "api/v1/Notification/GetAdminNotification",
    postAllNotificationData: "api/v1/Notification/UpdateAdminNotification",
    getRefreshToken: "api/v1/Account/getRefreshToken",

    };
